import React, { useEffect, useState } from "react";
import OgImage from "../../../assets/landingPages/homePage/Hero.png";
import { ReactComponent as TicketIcon } from "../../../assets/payment/ticket-discount.svg";
import { ReactComponent as TicketIconDark } from "../../../assets/payment/ticket-discount-dark.svg";
import { ReactComponent as CheckedIcon } from "../../../assets/payment/tick-square.svg";
import { ReactComponent as UnCheckedIcon } from "../../../assets/payment/tick-unCheck-square.svg";
import { ReactComponent as CardIcon } from "../../../assets/payment/card.svg";
import { ReactComponent as VisaCardIcon } from "../../../assets/payment/visa-svgrepo-com.svg";
import { ReactComponent as MasterCardIcon } from "../../../assets/payment/mastercard-svgrepo-com.svg";
import { ReactComponent as AmericanCardIcon } from "../../../assets/payment/amex-svgrepo-com.svg";
import { ReactComponent as MinusIcon } from "../../../assets/payment/minus.svg";
import { ReactComponent as MinusIconDark } from "../../../assets/payment/minus-dark.svg";
import { ReactComponent as PlusIcon } from "../../../assets/payment/add.svg";
import { ReactComponent as PlusIconDark } from "../../../assets/payment/add-dark.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  gettPlanByProductId,
  gettingPaymentStripes,
  resetPaymentUser,
  applyCoupoun,
  resetapplysCoupoun,
  removeCoupoun,
  resetremovesCoupoun,
} from "../../../redux/slices/paymentStripes/paymentStripesSlice";
import { toast } from "react-hot-toast";
import useLocales from "../../../hooks/useLocales";
import LoadingScreen from "../../../components/dashboard/LoadingScreen";
import { Helmet } from "react-helmet";

const PaymentDetailsFormPage = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const dispatch = useDispatch();
  const [paymentDetailDropDown, setPaymentDetailDropDown] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.userid;
  const [checked, setChecked] = useState(false);

  const [planDetails, setPlanDetails] = useState(null);

  const [code, setCode] = useState("");
  const [coupon, setCoupon] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amount, setAmount] = useState(0);
  const [couponDiscountAmount, setCouponDiscountAmount] = useState(0);
  const navigate = useNavigate();
  const [subLoading, setSubLoading] = useState(false);

  const { planType, planId } = useParams();

  useEffect(() => {
    const data = {
      Id: planId,
    };
    dispatch(gettPlanByProductId(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planId]);

  //
  const {
    getPlanByProductId,
    getPlanByProductIdSuccess,
    getPlanByProductIdError,
    getPlanByProductIdLoading,
  } = useSelector((state) => state?.paymentStripes);

  useEffect(() => {
    if (getPlanByProductIdSuccess && getPlanByProductId) {
      if (planType !== "month") {
        getPlanByProductId?.getAllStripeProductsAndPlans?.map((paln, i) => {
          if (paln.interval === "year") {
            setPlanDetails(paln);
          }
          return null;
        });
      } else {
        getPlanByProductId?.getAllStripeProductsAndPlans?.map((paln, i) => {
          if (paln.interval === planType) {
            setPlanDetails(paln);
          }
          return null;
        });
      }
    }
    if (getPlanByProductIdError) {
      navigate("/500");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPlanByProductIdLoading]);

  useEffect(() => {
    if (planDetails) {
      if (planType === "month") {
        setAmount(planDetails?.monthly_price);
      } else {
        setAmount(planDetails?.annual_price);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planDetails]);
  useEffect(() => {
    setTotalAmount(amount);
  }, [amount]);

  const {
    register,
    handleSubmit,
    reset,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  //  default values for profile
  const user_data = useSelector(
    (state) => state?.adminUser?.viewUserData?.user_data
  );

  const SubmitHandler = async (data) => {
    const { expiryDate } = data;
    let { cardNumber } = data;
    cardNumber = cardNumber.replace(/\s/g, "");
    setSubLoading(true);

    const [month, year] = expiryDate.split(" / ");

    const state = {
      id: planId,
      userId,
      product_id: planDetails?.product_id,
      plan_id: planDetails?.plan_id,
      firstName: data?.firstName,
      lastName: data?.lastName,
      renewal: checked,
      amount: totalAmount,
      coupon_discount: couponDiscountAmount,
      interval_count: planDetails?.interval_count,
      interval: planType,
      productName: planDetails?.name,
      cardnumber: cardNumber || data?.cardNumber,
      exp_month: month,
      exp_year: year,
      cvc: data?.cvv,
      codesIds: planDetails?.codes_ids,
      taxesIds: planDetails?.taxes_ids,
      couponCode: coupon?.code || "",
      customer_email: user_data?.email,
    };
    await dispatch(gettingPaymentStripes(state));
    reset();
    setSubLoading(false);
  };

  const {
    getPaymentStripe,
    getPaymentStripeError,
    getPaymentStripeSuccess,
    paymentStripeLoading,
    getPaymentStripeErrorMsg,
  } = useSelector((state) => state?.paymentStripes);

  useEffect(() => {
    if (getPaymentStripe?.status === "success" && getPaymentStripeSuccess) {
      toast.success(getPaymentStripe?.message);
      navigate("/pricing/payment/paymentSuccess");
    }
    if (getPaymentStripe?.status === "failed" && getPaymentStripeSuccess) {
      toast.error(getPaymentStripe?.message);
    }
    if (getPaymentStripeError && getPaymentStripeErrorMsg) {
      toast.error(getPaymentStripeErrorMsg?.message);
    }
    dispatch(resetPaymentUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPaymentStripeSuccess, getPaymentStripeError, paymentStripeLoading]);

  const [cardExp, setCardExp] = useState("");

  const formatExpiration = (value) => {
    const onlyNumbers = value.replace(/\D/g, "");
    const month = parseInt(onlyNumbers.slice(0, 2));
    const year = parseInt(onlyNumbers.slice(2));
    var matches = onlyNumbers.match(/\d{2,4}/g);
    var match = (matches && matches[0]) || "";
    var parts = [];
    let i = 0;
    let len;
    for (len = match.length; i < len; i += 2) {
      parts.push(match.substring(i, i + 2));
    }
    if (parts.length) {
      if (month > 12 || month < 1) {
        setError("expiryDate", {
          type: "validMonth",
          message: translate("addBlock.enter_valid_month"),
        });
        return "";
      } else {
        let newyear = new Date().getFullYear();
        newyear = newyear.toString().substr(-2);
        if (onlyNumbers.length >= 3 && year >= newyear) {
          clearErrors("expiryDate");
          return parts.join(" / ");
        } else {
          setError("expiryDate", {
            type: "validYear",
            message: translate("addBlock.enter_valid_year"),
          });
          return parts.join(" / ");
        }
      }
    } else {
      if (onlyNumbers.length >= 2) {
        if (month > 12 || month < 1) {
          setError("expiryDate", {
            type: "validMonth",
            message: translate("addBlock.enter_valid_month"),
          });
          return "";
        } else {
          clearErrors("expiryDate");
          return value;
        }
      } else {
        if (month > 12 || month < 10) {
          setError("expiryDate", {
            type: "validMonth",
            message: translate("addBlock.enter_valid_month"),
          });
          return value;
        } else {
          clearErrors("expiryDate");
          return value;
        }
      }
    }
  };

  const cardExpChangeHandler = (value) => {
    const date = formatExpiration(value);
    setCardExp(date);
  };

  const [cardNumber, setCardNumber] = useState("");
  const formateCardNumber = (value) => {
    var v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
    var matches = v.match(/\d{4,16}/g);
    var match = (matches && matches[0]) || "";
    var parts = [];
    let i = 0;
    let len;
    for (len = match.length; i < len; i += 4) {
      parts.push(match.substring(i, i + 4));
    }
    if (parts.length) {
      return parts.join(" ");
    } else {
      return value;
    }
  };
  const handleChangeCardInput = (value) => {
    var v = formateCardNumber(value);
    setCardNumber(v);
  };

  const formatCVV = (value) => {
    const onlyNumbers = value.replace(/\D/g, "");
    if (onlyNumbers.length >= 3 && onlyNumbers.length <= 4) {
      clearErrors("cvv");
    } else if (onlyNumbers.length) {
      setError("cvv", {
        type: "validCvv",
        message: translate("addBlock.please_enter_valid_cvv_number"),
      });
    } else {
      setError("cvv", {
        type: "required",
        message: translate("addBlock.cvv_is_required"),
      });
    }
    return onlyNumbers.replace(/^\d[0-9]\d{3,4}$/);
  };

  const removeCoupon = async () => {
    await dispatch(removeCoupoun({ code: coupon.code, userId }));
    await dispatch(resetremovesCoupoun());
    // setCoupon(null);
    // setCouponDiscountAmount(0);
    // setTotalAmount(amount);
  };
  const applyCoupon = async () => {
    await dispatch(applyCoupoun({ code, userId }));
    await dispatch(resetapplysCoupoun());
  };
  const {
    removesCoupoun,
    removeCoupounSuccess,
    removeCoupounError,
    removeCoupounLoading,
    removeCoupounErrorMsg,
  } = useSelector((state) => state?.paymentStripes);
  useEffect(() => {
    if (removeCoupounSuccess && removesCoupoun) {
      if (removesCoupoun?.status === "failed") {
        toast.error(removesCoupoun?.message);
      } else {
        toast.success(removesCoupoun?.message);
        setCoupon(null);
        setCouponDiscountAmount(0);
        setTotalAmount(amount);
      }
    }
    if (removeCoupounError) {
      toast.error(removeCoupounErrorMsg);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeCoupounLoading]);

  const {
    applysCoupoun,
    applyCoupounSuccess,
    applyCoupounError,
    applyCoupounLoading,
    applyCoupounErrorMsg,
  } = useSelector((state) => state?.paymentStripes);
  useEffect(() => {
    if (applyCoupounSuccess && applysCoupoun) {
      if (applysCoupoun?.status === "failed") {
        toast.error(applysCoupoun?.message);
      } else {
        toast.success(applysCoupoun?.message);
        setCoupon(applysCoupoun?.data);
      }
    }
    if (applyCoupounError) {
      toast.error(applyCoupounErrorMsg);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applyCoupounLoading]);

  useEffect(() => {
    if (coupon) {
      if (coupon?.percent_off) {
        const amount_detuct = (amount / 100) * coupon?.percent_off;
        setTotalAmount(amount - amount_detuct);
        setCouponDiscountAmount(amount_detuct);
      } else {
        setTotalAmount(amount - coupon?.amount_off);
        setCouponDiscountAmount(coupon?.amount_off);
      }
    } else {
      setTotalAmount(amount);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coupon]);

  const [cardType, setCardType] = useState("");

  useEffect(() => {
    identifyCardType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardNumber]);
  const identifyCardType = () => {
    const first4Digits = cardNumber.substring(0, 4);
    if (first4Digits.match(/^4/)) {
      setCardType("Visa");
    } else if (first4Digits.match(/^5[1-5]/)) {
      setCardType("MasterCard");
    } else if (first4Digits.match(/^3[47]/)) {
      setCardType("American Express");
    } else {
      setCardType("Unknown");
    }
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Payment | Bil.Bio</title>
        <meta property="og:title" content="Payment | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      {getPlanByProductIdLoading ? (
        <LoadingScreen />
      ) : (
        <div className="mt-[30px] px-6">
          <form onSubmit={handleSubmit((data) => SubmitHandler(data))}>
            <div
              className={`rounded-[20px] relative z-30 lg:py-5 lg:p-5 mt-[60px] lg:mt-[100px] mb-[50px] lg:mb-[150px] bg-transparent lg:bg-white dark:bg-dark-secondary ${
                darkMode ? "" : "lg:shadow-box_shadow_1"
              }`}
            >
              <div className="flex gap-[50px] lg:gap-[0px] flex-col lg:flex-row items-center">
                <div
                  className={`lg:block hidden order-2 lg:order-1 w-full lg:w-auto bg-[#F6F0E4] rounded-[20px] p-5 md:p-10 lg:p-0 lg:bg-transparent lg:shadow-none ${
                    darkMode ? "" : "shadow-box_shadow_1"
                  }`}
                >
                  <div className="hidden lg:block px-[25px] xl:px-[45px] rounded-t-[20px] pt-[43px] xl:pt-[63px] pb-[78px] xl:pb-[98px] bg-gradient-to-br from-[#FF765C] to-[#FF5349] text-center">
                    <h6 className="text-body_copy2_black xl:text-custom_h6 text-white">
                      {translate("addBlock.subscribe_start_customizing")}
                      <br className="hidden xl:block" />
                      {translate("addBlock.your_biolink_now")}
                    </h6>
                  </div>
                  <div className="bg-[#F6F0E4] lg:bg-[#FBF7F7] dark:bg-dark-primary lg:p-5 xl:p-[30px] lg:rounded-b-[20px]">
                    <div
                      className={`hidden lg:block -mt-[20%] xl:-mt-[20%] mb-7 xl:mb-10 rounded-[10px] py-[15px] xl:py-[20px] px-[20px] xl:px-[25px] w-full bg-white ${
                        darkMode ? "" : "shadow-box_shadow_1"
                      }`}
                    >
                      <p className="text-body_copy2_black xl:text-body_copy1_b text-heading_color">
                        {planDetails?.name}
                      </p>
                      <p className="text-small1 xl:text-body_copy2 text-heading_color">
                        $
                        {(planType === "month" && planDetails?.monthly_price) ||
                          planDetails?.annual_price}
                        /
                        {(planType === "month" &&
                          `${translate("addBlock.month")}`) ||
                          `${translate("addBlock.annual")}`}
                      </p>
                    </div>
                    <div className="px-[10px] xl:px-[20px] ">
                      <p className="text-body_copy2_black xl:text-body_copy1_b text-heading_color dark:text-color_v1_dark mb-[20px] xl:mb-[30px]">
                        {translate("addBlock.paymentDetails")}
                      </p>
                      <div className="flex flex-col gap-3 md:gap-4 lg:gap-3 xl:gap-4 ">
                        <div className="flex justify-between">
                          <p className="text-small2 xl:text-small1 dark:text-color_v2_dark">
                            {translate("addBlock.plan")}
                          </p>
                          <p className="text-small2_b xl:text-small1_bold dark:text-color_v2_dark">
                            {(planDetails?.isFree && "Free") || "Premium"}
                          </p>
                        </div>
                        <div className="flex justify-between">
                          <p className="text-small2 xl:text-small1 dark:text-color_v2_dark">
                            {translate("descriptions.type")}
                          </p>
                          <p className="text-small2_b xl:text-small1_bold dark:text-color_v2_dark">
                            {(planType === "month" &&
                              `${translate("addBlock.month")}`) ||
                              `${translate("addBlock.annual")}`}
                          </p>
                        </div>
                        <div className="flex justify-between">
                          <p className="text-small2 xl:text-small1 dark:text-color_v2_dark">
                            {translate("addBlock.renewal")}
                          </p>
                          <p className="text-small2_b xl:text-small1_bold dark:text-color_v2_dark">
                            {(checked && `${translate("addBlock.auto")}`) ||
                              `${translate("addBlock.off")}`}
                          </p>
                        </div>
                        <div className="flex justify-between">
                          <p className="text-small2 xl:text-small1 dark:text-color_v2_dark">
                            {translate("descriptions.paid_with")}
                          </p>
                          <p className="text-small2_b xl:text-small1_bold dark:text-color_v2_dark">
                            Stripe
                          </p>
                        </div>
                        <div className="flex justify-between">
                          <p className="text-small2 xl:text-small1 dark:text-color_v2_dark">
                            {translate("descriptions.price")}
                          </p>
                          <p className="text-small2_b xl:text-small1_bold text-main_color">
                            ${amount}
                          </p>
                        </div>
                        <div className="flex justify-between">
                          <p className="text-small2 xl:text-small1 dark:text-color_v2_dark">
                            {translate("addBlock.inclusive_tax")}
                          </p>
                          <p className="text-small2_b xl:text-small1_bold text-main_color">
                            $0
                          </p>
                        </div>
                        {coupon && (
                          <div className="flex justify-between">
                            <p className="text-small2 xl:text-small1">
                              Coupon Discount
                            </p>
                            <p className="text-small2_b xl:text-small1_bold text-main_color">
                              - ${couponDiscountAmount}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>

                    {coupon ? (
                      <div className="flex justify-between mt-6 md:mt-7 xl:mt-[30px] px-[10px] lg:px-[20px]">
                        <p className="text-small2 xl:text-small1 dark:text-color_v1_dark">
                          Code: {coupon?.code}
                        </p>
                        <button
                          type="button"
                          onClick={() => removeCoupon()}
                          className="text-small3_b xl:text-small3_b text-main_color cursor-pointer"
                          disabled={removeCoupounLoading}
                        >
                          {removeCoupounLoading ? (
                            <svg
                              aria-hidden="true"
                              role="status"
                              className="inline w-4 h-4 text-[#FF5349] animate-spin"
                              viewBox="0 0 100 101"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="#FF534966"
                              />
                              <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentColor"
                              />
                            </svg>
                          ) : (
                            "REMOVE"
                          )}
                        </button>
                      </div>
                    ) : (
                      <>
                        <div className="mt-6 md:mt-7 xl:mt-[30px] px-[10px] lg:px-[20px]">
                          <p className="text-main_color md:text-small1 text-small2">
                            {/* Have a coupon? */}{" "}
                            {translate("front_end_pages.pricing.have_a_coupon")}
                          </p>
                        </div>
                        <div className="relative mt-[4px] xl:mx-2.5">
                          <div className="absolute left-[15px] inset-y-0 flex justify-center items-center cursor-pointer">
                            {darkMode ? <TicketIconDark /> : <TicketIcon />}
                          </div>
                          <input
                            type={"text"}
                            value={code || ""}
                            onChange={(e) => setCode(e.target.value)}
                            className={`text-small2 xl:text-small1 border rounded-md focus:outline-none block w-full p-[11px] py-[3px] pl-[50px] pr-[60px] border-light_bg_v2 bg-light_bg_v5 focus:border-font_light_color placeholder:text-font_light_color placeholder:focus:text-heading_color dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark dark:bg-border_transparent dark:border-color_dark focus:dark:border-font_color`}
                            placeholder={translate(
                              "addBlock.enter_coupon_code"
                            )}
                          />
                          <div className="absolute right-[15px] inset-y-0 flex justify-center items-center cursor-pointer">
                            <button
                              type="button"
                              onClick={() => applyCoupon()}
                              className="text-small3_b text-main_color"
                              disabled={applyCoupounLoading}
                            >
                              {applyCoupounLoading ? (
                                <svg
                                  aria-hidden="true"
                                  role="status"
                                  className="inline w-4 h-4 text-[#FF5349] animate-spin"
                                  viewBox="0 0 100 101"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="#FF534966"
                                  />
                                  <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              ) : (
                                translate("addBlock.apply")
                              )}
                            </button>
                          </div>
                        </div>
                      </>
                    )}

                    <hr className="lg:mt-[20px] mt-6 md:mt-7 xl:mt-[30px] xl:mx-2.5 border dark:border-color_dark" />
                    <div className="flex justify-between lg:mt-[20px] mt-6 md:mt-7 xl:mt-[30px]  lg:mb-[20px] mx-3 xl:mx-5">
                      <p className="text-body_copy2_black xl:text-body_copy1_b dark:text-color_v1_dark">
                        {translate("descriptions.total_amount")}
                      </p>
                      <p className="text-body_copy2_black xl:text-body_copy1_b dark:text-color_v1_dark">
                        ${totalAmount}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className={`bg-white dark:bg-dark-secondary ${
                    darkMode ? "" : "shadow-box_shadow_1"
                  } lg:shadow-none rounded-[20px] py-10 p-5 lg:py-0 lg:p-0 order-1 lg:order-2 lg:pl-[40px] lg:pr-[20px] w-full lg:w-[83%] xl:pl-[70px] xl:pr-[50px] xl:w-[63%]`}
                >
                  <div className="w-full">
                    <h5 className="text-custom_h6 xl:text-custom_h5 text-heading_color dark:text-color_v1_dark text-center">
                      {translate("addBlock.set_up_your")} <br />
                      {translate("addBlock.credit_debit_card")}
                    </h5>

                    <div className="mt-[30px] flex flex-col gap-3 xl:gap-5">
                      <div>
                        <div className="relative ">
                          <input
                            type={"text"}
                            className={`remove-arrow text-small2 xl:text-body_copy2 border rounded-md focus:outline-none block w-full p-[13px] py-[5px] ps-2.5 xl:ps-[15px] xl:p-[15px] xl:py-[7px] pe-[50px] border-light_bg_v2 bg-light_bg_v5 dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark dark:bg-dark-secondary ${
                              errors?.cardNumber
                                ? "border-state_color_error placeholder:text-state_color_error"
                                : "border-light_bg_v2 focus:border-font_light_color placeholder:focus:text-heading_color placeholder:text-font_light_color dark:border-color_dark focus:dark:border-font_color"
                            }`}
                            placeholder={translate("addBlock.card_number")}
                            {...register("cardNumber", {
                              required: {
                                value: true,
                                message: `${translate(
                                  "addBlock.card_number_is_required"
                                )}`,
                              },
                            })}
                            value={cardNumber}
                            minLength={20}
                            maxLength={20}
                            onChange={(e) =>
                              handleChangeCardInput(e.target.value)
                            }
                          />
                          <div className="absolute end-[15px] inset-y-0 flex justify-center items-center ">
                            {cardType === "Visa" ? (
                              <VisaCardIcon className="w-9" />
                            ) : cardType === "MasterCard" ? (
                              <MasterCardIcon className="w-9" />
                            ) : cardType === "American Express" ? (
                              <AmericanCardIcon className="w-9" />
                            ) : (
                              <CardIcon
                                className={`${
                                  errors?.cardNumber
                                    ? "stroke-state_color_error"
                                    : darkMode
                                    ? "stroke-[#D5D5D5]"
                                    : "stroke-[#1E1E1E]"
                                }`}
                              />
                            )}
                          </div>
                        </div>
                        {errors?.cardNumber && (
                          <small className="text-state_color_error text-small3">
                            {errors?.cardNumber?.message}
                          </small>
                        )}
                      </div>
                      <div className="flex gap-3 xl:gap-5">
                        <div className="relative w-full">
                          <input
                            type={"text"}
                            className={`text-small2 xl:text-body_copy2 border rounded-md focus:outline-none block w-full p-[13px] py-[5px] ps-2.5 xl:ps-[15px] xl:p-[15px] xl:py-[7px] pr-[50px] border-light_bg_v2 bg-light_bg_v5 dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark dark:bg-dark-secondary ${
                              errors?.expiryDate
                                ? "border-state_color_error placeholder:text-state_color_error"
                                : "border-light_bg_v2 focus:border-font_light_color placeholder:focus:text-heading_color placeholder:text-font_light_color dark:border-color_dark focus:dark:border-font_color"
                            }`}
                            {...register("expiryDate", {
                              required: `${translate(
                                "addBlock.expiry_date_is_required"
                              )}`,
                              maxLength: {
                                value: 7,
                                message: translate(
                                  "addBlock.expiry_date_valid_month_year"
                                ),
                              },
                              minLength: {
                                value: 7,
                                message: translate(
                                  "addBlock.expiry_date_valid_month_year"
                                ),
                              },
                            })}
                            minLength={7}
                            maxLength={7}
                            value={cardExp}
                            onChange={(e) => {
                              cardExpChangeHandler(e.target.value);
                            }}
                            placeholder={translate("addBlock.expiry_date")}
                          />

                          {errors?.expiryDate && (
                            <small className="text-state_color_error text-small3">
                              {errors?.expiryDate?.message}
                            </small>
                          )}
                        </div>
                        <div className="relative w-full">
                          <input
                            type={"number"}
                            className={`remove-arrow text-small2 xl:text-body_copy2 border rounded-md focus:outline-none block w-full p-[13px] py-[5px] ps-2.5 xl:ps-[15px] xl:p-[15px] xl:py-[7px] pr-[50px] border-light_bg_v2 bg-light_bg_v5 dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark dark:bg-dark-secondary ${
                              errors?.cvv
                                ? "border-state_color_error placeholder:text-state_color_error"
                                : "border-light_bg_v2 focus:border-font_light_color placeholder:focus:text-heading_color placeholder:text-font_light_color dark:border-color_dark focus:dark:border-font_color"
                            }`}
                            placeholder="CVV"
                            maxLength={4}
                            {...register("cvv", {
                              required: {
                                value: true,
                                message: `${translate(
                                  "addBlock.cvv_is_required"
                                )}`,
                                maxLength: 4,
                              },
                              validate: {
                                minLength: (v) =>
                                  v.length >= 3 ||
                                  `${translate(
                                    "addBlock.please_enter_valid_card_number"
                                  )}`,
                                maxLength: (v) =>
                                  v.length <= 4 ||
                                  `${translate(
                                    "addBlock.please_enter_valid_cvv_number"
                                  )}`,
                              },
                            })}
                            onChange={(e) =>
                              (e.target.value = formatCVV(e.target.value))
                            }
                          />

                          {errors?.cvv && (
                            <small className="text-state_color_error text-small3">
                              {errors?.cvv?.message}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="relative ">
                        <input
                          type={"text"}
                          className={`text-small2 xl:text-body_copy2 border rounded-md focus:outline-none block w-full p-[13px] py-[5px] ps-2.5 xl:ps-[15px] xl:p-[15px] xl:py-[7px] pr-[50px] border-light_bg_v2 bg-light_bg_v5 dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark dark:bg-dark-secondary ${
                            errors?.firstName
                              ? "border-state_color_error placeholder:text-state_color_error"
                              : "border-light_bg_v2 focus:border-font_light_color placeholder:focus:text-heading_color placeholder:text-font_light_color dark:border-color_dark focus:dark:border-font_color"
                          }`}
                          placeholder={translate("firstName")}
                          {...register("firstName", {
                            required: `${translate(
                              "descriptions.firstName_required"
                            )}`,
                            pattern: {
                              value: /^[a-zA-Z\s]*$/,
                              message: `${translate(
                                "addBlock.invalid_characters_in_name"
                              )}`,
                            },
                          })}
                        />
                        {errors?.firstName && (
                          <small className="text-state_color_error text-small3">
                            {errors?.firstName?.message}
                          </small>
                        )}
                      </div>
                      <div className="relative ">
                        <input
                          type={"text"}
                          className={`text-small2 xl:text-body_copy2 border rounded-md focus:outline-none block w-full p-[13px] py-[5px] ps-2.5 xl:ps-[15px] xl:p-[15px] xl:py-[7px] pr-[50px] border-light_bg_v2 bg-light_bg_v5 dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark dark:bg-dark-secondary ${
                            errors?.lastName
                              ? "border-state_color_error placeholder:text-state_color_error"
                              : "border-light_bg_v2 focus:border-font_light_color placeholder:focus:text-heading_color placeholder:text-font_light_color dark:border-color_dark focus:dark:border-font_color"
                          }`}
                          placeholder={translate(
                            "front_end_pages.contact.last_name"
                          )}
                          {...register("lastName", {
                            required: `${translate(
                              "front_end_pages.contact.last_name_required"
                            )}`,
                            pattern: {
                              value: /^[a-zA-Z\s]*$/,
                              message: `${translate(
                                "addBlock.invalid_characters_in_name"
                              )}`,
                            },
                          })}
                        />
                        {errors?.lastName && (
                          <small className="text-state_color_error text-small3">
                            {errors?.lastName?.message}
                          </small>
                        )}
                      </div>
                      <div className="flex items-center gap-5 py-[14px] xl:py-[15px] xl:px-5 px-[15px] border border-black rounded-lg dark:border-color_v2_dark">
                        <div className="w-full">
                          <p className="text-small1_bold xl:text-body_copy1_b text-heading_color dark:text-color_v1_dark ">
                            {planDetails?.name}
                          </p>
                          <p className="text-small2 xl:text-body_copy2 text-heading dark:text-color_v2_dark">
                            $
                            {(planType === "month" &&
                              planDetails?.monthly_price) ||
                              planDetails?.annual_price}{" "}
                            /{" "}
                            {(planType === "month" &&
                              `${translate("addBlock.month")}`) ||
                              `${translate("addBlock.annual")}`}
                          </p>
                        </div>
                        <div>
                          <div className="cursor-pointer text-small3_b xl:text-small1_bold text-main_color">
                            <Link to={"/pricing"}>
                              {translate("addBlock.change")}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <label
                      htmlFor="checked-checkbox"
                      className="text-small2 xl:text-body_copy2 text-heading_color"
                    >
                      <div className="mt-[30px] flex  gap-3 cursor-pointer">
                        <div>
                          {checked ? (
                            <CheckedIcon className="w-[18px] h-[18px] xl:w-[24px] xl:h-[24px]" />
                          ) : (
                            <UnCheckedIcon className="w-[18px] h-[18px] xl:w-[24px] xl:h-[24px]" />
                          )}
                        </div>

                        <input
                          id="checked-checkbox"
                          type="checkbox"
                          onChange={(e) => setChecked(e.target.checked)}
                          className="hidden w-6 h-6 cursor-pointer "
                        />
                        <p className="text-small2 md:text-body_copy2 dark:text-color_v2_dark">
                          {translate("addBlock.renew_plan_automatically")}
                        </p>
                      </div>
                    </label>

                    <button
                      type="submit"
                      disabled={subLoading}
                      className={`cursor-pointer hidden lg:block w-full text-center mt-[30px] xl:mt-[50px] bg-main_color text-white pt-[9px] xl:pt-[13px] pb-2 xl:pb-3 px-[26px] xl:px-10 rounded-full text-small2_b xl:text-small1_bold ${
                        subLoading ? "opacity-70" : ""
                      }`}
                    >
                      {subLoading ? (
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline w-7 h-7 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentColor"
                          />
                        </svg>
                      ) : (
                        translate("addBlock.make_payment")
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`lg:hidden rounded-[20px] relative z-30 py-[30px] p-5 mb-[80px] bg-[#F6F0E4] dark:bg-dark-primary border dark:border-color_v2_dark ${
                darkMode ? "" : "shadow-box_shadow_1"
              }`}
            >
              <div
                onClick={() => setPaymentDetailDropDown(!paymentDetailDropDown)}
                type="button"
                className="px-2.5 cursor-pointer flex justify-between items-center "
              >
                <div className="w-full ">
                  <p className="text-body_copy2_black text-heading_color dark:text-color_v1_dark ">
                    {translate("addBlock.paymentDetails")}
                  </p>
                </div>
                <div className="cursor-pointer">
                  {paymentDetailDropDown ? (
                    darkMode ? (
                      <MinusIconDark />
                    ) : (
                      <MinusIcon />
                    )
                  ) : darkMode ? (
                    <PlusIconDark />
                  ) : (
                    <PlusIcon />
                  )}
                </div>
              </div>
              <hr className="my-[20px] border border-b-light_bg_v1 dark:border-color_dark" />
              {paymentDetailDropDown && (
                <>
                  <div className="px-2.5 flex flex-col gap-3">
                    <div className="flex justify-between">
                      <p className="text-small2 dark:text-color_v2_dark">
                        {translate("addBlock.plan")}
                      </p>
                      <p className="text-small2_b dark:text-color_v2_dark">
                        {(planDetails?.isFree && "Free") || "Premium"}
                      </p>
                    </div>
                    <div className="flex justify-between ">
                      <p className="text-small2 dark:text-color_v2_dark">
                        {translate("descriptions.type")}
                      </p>
                      <p className="text-small2_b dark:text-color_v2_dark">
                        {(planType === "month" &&
                          `${translate("addBlock.month")}`) ||
                          `${translate("addBlock.annual")}`}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-small2 dark:text-color_v2_dark">
                        {translate("addBlock.renewal")}
                      </p>
                      <p className="text-small2_b dark:text-color_v2_dark">
                        {translate("addBlock.auto")}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-small2 dark:text-color_v2_dark">
                        {translate("descriptions.paid_with")}
                      </p>
                      <p className="text-small2_b dark:text-color_v2_dark">
                        Stripe
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-small2 dark:text-color_v2_dark">
                        {translate("descriptions.price")}
                      </p>
                      <p className="text-small2_b text-main_color">
                        $
                        {(planType === "month" && planDetails?.monthly_price) ||
                          planDetails?.annual_price}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-small2 dark:text-color_v2_dark">
                        {translate("addBlock.inclusive_tax")}
                      </p>
                      <p className="text-small2_b text-main_color">$0</p>
                    </div>
                    {coupon && (
                      <div className="flex justify-between">
                        <p className="text-small2">Coupon Discount</p>
                        <p className="text-small2_b text-main_color">
                          - ${couponDiscountAmount}
                        </p>
                      </div>
                    )}
                  </div>
                  {!coupon && (
                    <>
                      <div className="mt-6 lg:mt-[30px] px-2.5">
                        <p className="text-main_color text-small2">
                          {/* Have a coupon? */}{" "}
                          {translate("front_end_pages.pricing.have_a_coupon")}
                        </p>
                      </div>
                      <div className="relative mt-[4px]">
                        <div className="absolute left-[15px] inset-y-0 flex justify-center items-center cursor-pointer">
                          {darkMode ? <TicketIconDark /> : <TicketIcon />}
                        </div>
                        <input
                          type={"text"}
                          value={code || ""}
                          onChange={(e) => setCode(e.target.value)}
                          className={`text-small2 border rounded-md focus:outline-none block w-full p-[11px] py-[3px] pl-[50px] pr-[60px] border-light_bg_v2 bg-light_bg_v5 focus:border-font_light_color placeholder:text-font_light_color placeholder:focus:text-heading_color dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark dark:bg-border_transparent dark:border-color_dark focus:dark:border-font_color`}
                          placeholder={translate("addBlock.enter_coupon_code")}
                        />
                        <div className="absolute right-[15px] inset-y-0 flex justify-center items-center cursor-pointer">
                          <button
                            type="button"
                            onClick={() => applyCoupon()}
                            className="text-small3_b text-main_color"
                            disabled={applyCoupounLoading}
                          >
                            {applyCoupounLoading ? (
                              <svg
                                aria-hidden="true"
                                role="status"
                                className="inline w-4 h-4 text-[#FF5349] animate-spin"
                                viewBox="0 0 100 101"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                  fill="#FF534966"
                                />
                                <path
                                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                  fill="currentColor"
                                />
                              </svg>
                            ) : (
                              translate("addBlock.apply")
                            )}
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                  <hr className="mt-[30px]  border border-b-light_bg_v1 dark:border-color_dark" />
                </>
              )}
              <div className="flex justify-between mt-5 px-2.5">
                <p className="text-body_copy2_black dark:text-color_v1_dark">
                  {translate("descriptions.total_amount")}
                </p>
                <p className="text-body_copy2_black dark:text-color_v1_dark">
                  ${totalAmount}
                </p>
              </div>
              {coupon && (
                <div className="flex justify-between mt-3 px-2.5">
                  <p className="text-small2 dark:text-color_v1_dark">Code: {coupon?.code}</p>
                  <button
                    type="button"
                    onClick={() => removeCoupon()}
                    className="text-small3_b  text-main_color"
                    disabled={removeCoupounLoading}
                  >
                    {removeCoupounLoading ? (
                      <svg
                        aria-hidden="true"
                        role="status"
                        className="inline w-4 h-4 text-[#FF5349] animate-spin"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="#FF534966"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentColor"
                        />
                      </svg>
                    ) : (
                      "REMOVE"
                    )}
                  </button>
                </div>
              )}
              <div>
                <button
                  type="submit"
                  disabled={subLoading}
                  className={`cursor-pointer w-full text-center mt-[24px] xl:mt-[50px] bg-main_color text-white pt-[9px] xl:pt-[13px] pb-2 xl:pb-3 px-[26px] xl:px-10 rounded-full text-small2_b xl:text-small1_bold ${
                    subLoading ? "opacity-70" : ""
                  }`}
                >
                  {subLoading ? (
                    <svg
                      aria-hidden="true"
                      role="status"
                      className="inline w-7 h-7 text-white animate-spin"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#E5E7EB"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentColor"
                      />
                    </svg>
                  ) : (
                    translate("addBlock.make_payment")
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default PaymentDetailsFormPage;
